module.exports = __webpack_public_path__ + "static/GT-America-Standard-Light-e157c3080db0c971120860f48a77be0d.woff";